import { Component, OnInit } from '@angular/core';
import { INotification } from '../../interfaces';
import { NotificationService } from '../../services/notification.service';
import { CommonModule } from '@angular/common';
import { SinceDatePipe } from '../../pipes/since-date.pipe';
import { SocketService } from '../../services/socket.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-notifications',
  standalone: true,
  imports: [CommonModule, SinceDatePipe],
  templateUrl: './all-notifications.component.html',
  styleUrl: './all-notifications.component.scss'
})
export class AllNotificationsComponent implements OnInit {
  notifications!: INotification[];
  constructor(
    private notificationService: NotificationService, 
    private socketService: SocketService,
    private router: Router
  ) {


  }
  ngOnInit(): void {

    this.socketService.refreshNotification$.subscribe((response: any) => {
      this.notifications = response["data"]["notifications"];
      this.notifications = this.notifications;
      console.log("notification", this.notifications);

    });
  };


  markAsRead(notificationId: number) {
    const notification = this.notifications.find(n => n.id == notificationId) as INotification
    if (notification.is_read) {
      return;
    } else {

      this.notificationService.markAsRead(notificationId).subscribe(() => {

        notification["is_read"] = true
      })
    }
  }

  // Handle notification click - mark as read and navigate
  handleNotificationClick(notification: INotification) {
    this.markAsRead(notification.id);
    this.navigateToEntity(notification);
  }

  navigateToEntity(notification: INotification) {
    const type = notification.type;
    const data = notification.data;
    const strategyId = notification.strategic_plan_id;

    switch (type) {
      // Project submission request - navigate to project review page
      case 'submission_request':
        if (data?.id) {
          this.router.navigate(['/strategies', strategyId, 'projects', data.id], {
            state: { hasAccess: true, scrollToReview: true }
          });
        }
        break;

      // Project submission response - navigate to project to see results
      case 'submission_response':
        if (data?.id || data?.parentEntityId) {
          this.router.navigate(['/strategies', strategyId, 'projects', data.id || data.parentEntityId], {
            state: { hasAccess: true, scrollToReview: true }
          });
        }
        break;

      // Milestone audit request - navigate to file auditor
      case 'milestone_output_audit_request':
        if (data?.parentEntityId && data?.subEntityId) {
          this.router.navigate(['/project-file-auditor'], {
            queryParams: { 
              strategyId: strategyId, 
              parentEntityId: data.parentEntityId, 
              subEntityId: data.subEntityId 
            }
          });
        }
        break;

      // Milestone audit response - navigate to project
      case 'milestone_output_audit_response':
        if (data?.parentEntityId) {
          this.router.navigate(['/strategies', strategyId, 'projects', data.parentEntityId], {
            state: { hasAccess: true }
          });
        }
        break;

      // Indicator outcome proof request - navigate to indicator auditor
      case 'outcome_proof_audit_request':
        if (data?.parentEntityId && data?.subEntityId) {
          this.router.navigate(['/indicator-FileAuditsingle'], {
            queryParams: { 
              strategyId: strategyId, 
              parentEntityId: data.parentEntityId, 
              subEntityId: data.subEntityId 
            }
          });
        }
        break;

      // Indicator outcome proof response - navigate to indicator
      case 'outcome_proof_audit_response':
        if (data?.parentEntityId) {
          this.router.navigate(['/strategies', strategyId, 'indicators', data.parentEntityId]);
        }
        break;

      // Project execution stop/resume - navigate to project
      case 'project_execution_stop':
      case 'project_execution_resume':
        if (data?.id) {
          this.router.navigate(['/strategies', strategyId, 'projects', data.id], {
            state: { hasAccess: true }
          });
        }
        break;

      // Approval notifications - navigate to project
      case 'approval_message':
      case 'SectionAdminApproved':
      case 'SectionAdminReject':
      case 'DepartmentAdminApproved':
      case 'DepartmentAdminReject':
      case 'SectorAdminApproved':
      case 'SectorAdminReject':
        if (data?.id) {
          this.router.navigate(['/strategies', strategyId, 'projects', data.id], {
            state: { hasAccess: true }
          });
        }
        break;

      // Milestone due reminder - navigate to project
      case 'milestone_due_reminder':
        if (data?.parentEntityId) {
          this.router.navigate(['/strategies', strategyId, 'projects', data.parentEntityId], {
            state: { hasAccess: true }
          });
        }
        break;

      default:
        console.warn('No navigation route defined for notification type:', type);
    }
  }
}
